import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ProcedureTemplateComponent from './procedure-template.component';

let ProcedureTemplateModule = angular.module('ProcedureTemplate', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newProcedureTemplate', {
            url: '/procedureTemplates/new',
            component: 'procedureTemplate',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
            }
        })
        .state('editProcedureTemplate', {
            url: '/procedureTemplates/:id',
            component: 'procedureTemplate',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                procedureTemplate: (
                    ProcedureTemplatesService,
                    $stateParams
                ) => {
                    return ProcedureTemplatesService.findById($stateParams.id, {
                        include: [
                            {
                                relation: 'procedureTemplateItemTemplates',
                                scope: {
                                    order: 'id ASC',
                                    include: ['itemTemplate']
                                }
                            },
                            'children'
                        ]
                    });
                }
            }
        });
})
.component('procedureTemplate', ProcedureTemplateComponent)
.name;

export default ProcedureTemplateModule;
